import { Text, Container, List, ListItem, ListIcon, Link } from '@chakra-ui/layout';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export default function Guidelines(){
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return(
        <div>
            <Container maxW={["90%", "90%", "90%", "80%"]} mb={12} mt={"40px"}  p={[0, 0, 0, 4]}>
                <Text fontSize="2xl" fontWeight="900">
                    PROXIMY COMMUNITY GUIDELINES
                </Text>
                <Text fontSize="1xl" fontWeight="900">
                20.05.11
                </Text>
                <Text fontSize="2xl" fontWeight="900"  mt="20px"  >
                    “Proximy is about positivity, kindness, diversity, and coming together to contribute to solving a global problem of ending social isolation.”  
                </Text>
                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    - Proximy Team
                </Text>
                <br/>
                <Text fontSize="1xl" mt="20px">
                    Proximy is a platform for creating meaningful connections with people in your proximity and these Guidelines are created to ensure everyone has a safe and enjoyable experience. Failure to follow these guidelines may result in losing access to our platform indefinitely. 
                </Text>
                <br/>

                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Respect:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    Culture and diversity are at the root of who we are as a community. This means you should respect people’s interests, beliefs, cultures, and opinions. Proximy will take a strong stance against any form of racism, hate speech, and abusive behaviour. We encourage all of our community users to report those who do not follow these guidelines.
                </Text>
                <br/>


                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Speech:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    Social isolation is a global problem with each individual facing it in their own way. How you talk to people, and how you want to be spoken to reflects through the content you post and the words that you write. Please be empathetic and respectful with others on the platform. Our goal is to end social isolation and bring people together so communicate how you would if you were meeting them in person, because that is the goal. Your speech should bring people together, not spread us further apart.
                </Text>


                <br/>


                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Scamming and Spamming:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    Proximy is for helping our community, not abusing it. Scamming or spamming will not be tolerated. This includes: financial solicitation, creating intentionally false events or groups, forcibly pushing a personal agenda or company products, repetitive comments, any physical or emotional scams as well as misleading photos, links or posts designed to trick users.
                </Text>


                <Text fontSize="1xl" mt="20px">
                    Content on Proximy is meant for community involvement and creating opportunities for its users to get engaged locally. The content is not meant and should never be used maliciously against other users in an attempt to stalk, hurt, defame or negatively impact others lives or intentionally cause harm. 
                </Text>

                <br/>


                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Sexual Conduct:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    We value your freedom of expression, however we do not permit nudity or sexually explicit content anywhere on the platform. Proximy is not a dating app and all in-person meetings are expected to be non-sexual.
                </Text>

                    <br/>


                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Impersonation:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    Your Proximy profile should be an accurate representation of you. The community is built of real people embracing each other's differences and uniqueness. Please do not catfish other members or pretend to be someone you are not.
                </Text>

                <br/>


                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Reporting:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    To keep our community safe, please report anything that violates our guidelines or anything that you feel is inappropriate for the platform. We are all part of the community and it will flourish if we use it for its intended purpose. Please report any concerning content or profiles directly to info@proximy.ca.
                </Text>

                <br/>


                <Text fontSize="1xl" fontWeight="900"  mt="20px">
                    Feedback:
                </Text>
                <Text fontSize="1xl" mt="20px">
                    We will be consistently improving our online community. If you have any constructive feedback, please get in touch with our team at info@proximy.ca. Help us improve the platform experience by reporting violations, bugs, errors, and suggestions!
                </Text>

                <Text fontSize="1xl" mt="20px">
                    If you do not choose to follow these guidelines, you will receive a warning (unless the team decides to block without warning at our discretion). If you choose to ignore the warning, you will risk losing your Proximy account. These guidelines are designed to make Proximy a safe place for all of our users to enjoy and focus on our mission of ending social isolation.
                </Text>

            

            </Container>
        </div>
    )
}